module.exports = __webpack_public_path__ + "static/media/serviceArea.6503accd.png";